export enum PageConfigType {
    BwicMonitorAll = 'BwicMonitorAll',
    Portfolio = 'Portfolio',
    Inventory = 'Inventory',
    DealerInventory = 'DealerInventory',
}